
import React from 'react';
import { withTranslation } from 'react-i18next';
import { history } from '../../routes';
import config from '../../config';

import LayoutSmall from '../../components/layout/LayoutSmall';
import Button from '../../components/commons/Button';


class InfoHelp extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
    }
  }
  
  componentDidMount() {
    console.log('HELP PAGE');
  }

  onExit = async values => {
    history.push(config.ROUTES.HOME);        
  }
 
  render() {
    return (
      <LayoutSmall
        header={{ 
          className: "bg-primary",
          title: this.t("Help"),
          left: { icon: 'arrow_left', action: () => history.push(config.ROUTES.INFO) }
        }}      
        main={{ 
          className: "light-primary-bg text-gray-700",
        }}
      >
        <p>
          Para más información
        </p>
        <Button
          className="btn btn-lg btn-block btn-secondary my-4"
          title={this.t("Continue")}
          onClick={this.onExit}
        />
      </LayoutSmall>
    ) 
  }
}

export default withTranslation()(InfoHelp);
